import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { __TOPONYMY_API_URL__ } from 'shell/constants/environment';
import { ItemVM } from 'shell/view-models/item';
import { HttpResponseList } from 'shell/models/http-response';
import { TownHall } from 'shell/models/town-hall';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';

interface MunicipalityProps {
  disabled?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  label?: string;
  id?: string;
  required?: boolean;
  error?: boolean;
}

const MunicipalityComponent = ({
  disabled,
  onChange,
  value,
  label = 'Municipio',
  id = 'municipality',
  required,
  error,
}: MunicipalityProps): React.ReactElement => {
  const [municipalitiesBE] = useHttpFetch<HttpResponseList<TownHall>, Array<ItemVM>>(
    `${__TOPONYMY_API_URL__}/municipi`,
    {
      onBootstrap: true,
      options: {
        method: 'GET',
        loading: true,
        errorCatching: true,
      },
      transformer: (response) => {
        return response.data.payload.list.map((municipality) => ({
          id: municipality.key.codice,
          value: municipality.descrizione,
        }));
      },
    }
  );

  const municipalities: Array<ItemVM> = (municipalitiesBE.data as Array<ItemVM>) || [];

  return (
    <PmiFormControl fullWidth>
      <InputLabel id={`${id}-label`} error={error} disabled={disabled}>
        {required ? `${label} *` : label}
      </InputLabel>
      <PmiSelect
        labelId={id}
        id={id}
        name={id}
        value={value.toString()}
        label={required ? `${label} *` : label}
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        {municipalities.map((municipality: ItemVM) => (
          <MenuItem key={municipality.id} value={municipality.id}>
            {municipality.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

MunicipalityComponent.displayName = 'Municipality list component';

const Municipality = memo(MunicipalityComponent) as typeof MunicipalityComponent;

export default Municipality;
